module.exports = __webpack_public_path__ + "static/media/monte-seu-plano.6afc9233.svg";